module.exports = __webpack_public_path__ + "media/application/images/svgs/social/linkedin-4ebed8f3642ba8356ae8711a9053f522.svg";